"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildImageUrl = void 0;
const constants_1 = require("../../lib/constants");
const buildImageUrl = ({ serviceUrl, src, width, height, isWebpSupported = false, devicePixelRatio }) => {
    try {
        const url = new URL(serviceUrl);
        url.searchParams.append(constants_1.ServiceUrlParameters.URL, src);
        if (width)
            url.searchParams.append(constants_1.ServiceUrlParameters.WIDTH, width.toString());
        if (height)
            url.searchParams.append(constants_1.ServiceUrlParameters.HEIGHT, height.toString());
        if (devicePixelRatio) {
            url.searchParams.append(constants_1.ServiceUrlParameters.DEVICE_PIXEL_RATIO, devicePixelRatio);
        }
        if (isWebpSupported) {
            url.searchParams.append(constants_1.ServiceUrlParameters.FORMAT, constants_1.ImageOutputFormat.WEBP);
        }
        url.searchParams.append(constants_1.ServiceUrlParameters.FOCAL_POINT, constants_1.FOCAL_POINT_AUTO);
        return url.toString();
    }
    catch (err) {
        // Fallback to original src if URL construction fails
        return src;
    }
};
exports.buildImageUrl = buildImageUrl;
//# sourceMappingURL=buildImageUrl.js.map